// @flow
import {
    CLEAR_RESOURCE,
    MARK_ITEM_AS_DOWNLOADING,
    SET_FAVOURITE_RESOURCE,
    SET_RESOURCE,
    UPDATE_AVAILABLE_OFFLINE_FAILED,
    UPDATE_AVAILABLE_OFFLINE_START,
    UPDATE_AVAILABLE_OFFLINE_SUCCESS,
} from '../actions/resource';

import type { Action } from './types';


const initialState = {
    isDownloadedSetted: false,
    isSettingDownloaded: false,
};

function markItemAsDownloading( id, isDownloading, resource ) {

    resource.separatedFiles.dataForHeader.map( file => {
        if ( Number( id ) === Number( file.id ) ) {
            file.isDownloading = isDownloading;
        }
        return null;
    } );

    resource.separatedFiles.dataForTable.map( file => {
        if ( Number( id ) === Number( file.id ) ) {
            file.isDownloading = isDownloading;
        }
        return null;
    } );

    return resource;
}


//Reducer that manages a resource
export default function resource( state = initialState, action: Action ) {
    switch ( action.type ) {
        case SET_RESOURCE:
            //Action that adds a download into the queue.
            const { resource } = action;
            return { ...resource, ...state, isDownloadedSetted: false, isSettingDownloaded: false };
        case UPDATE_AVAILABLE_OFFLINE_START:
            return { ...state, isDownloadedSetted: false, isSettingDownloaded: true };
        case UPDATE_AVAILABLE_OFFLINE_SUCCESS:
            const separatedFiles = action.result;
            return { ...state, separatedFiles: separatedFiles, isDownloadedSetted: true, isSettingDownloaded: false };
        case UPDATE_AVAILABLE_OFFLINE_FAILED:
            return { ...state, isDownloadedSetted: true, isSettingDownloaded: false };
        case MARK_ITEM_AS_DOWNLOADING:
            return { ...state, ...markItemAsDownloading( action.id, action.isDownloading, state ) };
        case SET_FAVOURITE_RESOURCE:
            return { ...state, isFav: action.isFav };
        case CLEAR_RESOURCE:
            return initialState;

        default:
            return state;
    }
}